import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import {CurrencyPipe, DatePipe, formatCurrency, JsonPipe, NgIf} from "@angular/common";
import { ClrDatagridModule, ClrIconModule, ClrModalModule, ClrTabsModule, ClrTooltipModule } from "@clr/angular";
import { getTenantLetterAssets } from '../../../_shared/utils/letter-assets';
import { getTenantConfig } from '../../../_shared/utils/tenant-context';
import {
  ConfirmationList,
  Confirmations,
  Delivery,
  OffersList,
  Personen,
  SingleConfirmation
} from "../../../_shared/interfaces";
import {
  ClarityIcons,
  angleIcon,
  fileIcon,
  eyeHideIcon,
  pencilIcon,
  minusCircleIcon,
  noteIcon,
  infoCircleIcon,
} from "@cds/core/icon";
import PackageJson from "../../../../../package.json";
import {
  AlertService,
  ConditionStoreService, ConfirmationStoreService, ContactsStoreService,
  FileStoreService, IAlertType, JobsStoreService,
  OffersStoreService,
  PersonsStoreService,
  ProjectsStoreService,
  StaffStoreService
} from "../../../_shared/services";
import { ConfirmationEditPositionComponent } from "./confirmation-edit-position/confirmation-edit-position.component";

import { environment as env } from "../../../../environments/environment";
import moment from "moment";

@Component({
  selector: 'app-confirmation-details',
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    DatePipe,
    ClrTabsModule,
    ClrIconModule,
    ClrDatagridModule,
    CurrencyPipe,
    ClrTooltipModule,
    ClrModalModule,
    JsonPipe,
    ConfirmationEditPositionComponent
  ],
  templateUrl: './confirmation-details.component.html',
  styleUrl: './confirmation-details.component.sass'
})
export class ConfirmationDetailsComponent {
  confirmation: Confirmations = new SingleConfirmation();
  positions: Delivery[] = [];
  person: Personen[] = [];
  projectId: string = '';
  confirmationId: number = 0;
  jobId: number = 0;
  companyId: number = 0;
  loading1: boolean = true;
  loading2: boolean = true;
  selected: ConfirmationList[] = [];
  editPos: number = 0;  // 0 = Anzeige; 1 = Änderungsmodus, 2 = Position ändern
  positionId: number = 0;
  partId: number = 0;
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  staffPhone: string = '';
  personFirstName: string = '';
  personLastName: string = '';
  personSalutation: string = '';
  personEMail: string = '';
  personPhone: string = '';
  personId: number = 0;
  offerCondition: any = "";
  deliveryCondition: any = "";
  paymentCondition: any = "";
  deliveryConditionHasOption: boolean = false;

  public ppsverion: string = PackageJson.version;

  // Für Ausdruck
  basic = false;
  clrModalSize: string = '';
  devMode: boolean;
  private readonly tenantConfig = getTenantConfig();

  documentDefinition = getTenantLetterAssets().a4Letter;

  constructor(
    private confss: ConfirmationStoreService,
    private condss: ConditionStoreService,
    private contss: ContactsStoreService,
    private staffss: StaffStoreService,
    private offerss: OffersStoreService,
    private persss: PersonsStoreService,
    private projss: ProjectsStoreService,
    private filess: FileStoreService,
    private jobss: JobsStoreService,
    private router: Router,
    private datePipe: DatePipe,
    private alertDispatcher: AlertService,
    private route: ActivatedRoute
  )
  {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(noteIcon, infoCircleIcon, minusCircleIcon)
  }

  ngOnInit(): void {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('projid') ?? '';
    this.confirmationId = parseInt(params.get('confid') ?? '0', 10);
    this.jobId = parseInt(params.get('jobid') ?? '0', 10);
    this.loadConfirmation(this.projectId, this.jobId, this.confirmationId);
    this.loadConfirmationsPosition();
  }

  loadConfirmation(projectID: string, jobID: number, confirmationID: number){
    this.confss.getConfirmation(projectID, jobID, confirmationID).subscribe({
      next: data1  => {
        if (!data1 || !data1.object) {
          this.alertDispatcher.show({
            message: 'Keine Confirmationdaten gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.confirmation = data1.object[0];

      // Mitarbeiter personalisieren
      this.staffStatus(this.confirmation.employee_phm);

      // Person ermitteln
      this.loadPersonData(this.confirmation.employee_leader);

      //Bedingungen ermitteln
      this.deliveryCondition = this.getCondition(this.confirmation.cond_delivery, 1);
      this.paymentCondition = this.getCondition(this.confirmation.cond_payment, 2);
      this.offerCondition = this.getCondition(this.confirmation.cond_offer, 3);
    },
    complete: () => {
      this.loading1 = false;
      },
      error: () => {
        return
      }
    });
  }

  loadConfirmationsPosition() {
    this.confss.getConfirmationsPosition(this.projectId, this.confirmationId, '0', '0').subscribe({
      next: data2 => {
        if (!data2 || !data2.object) {
          this.alertDispatcher.show({
            message: 'Keine Confirmationpositionen gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
      this.positions = data2.object;
      },
      complete: () => {
        this.loading2 = false;
      },
      error: () => {
        return
      }
    });
  }

  updatePositionMode(index: number, positionId: number, partId: number) {
    this.editPos = 2;
    this.positionId = positionId;
    this.partId = partId;
  }

  loadPersonData(person: number) {
    return this.persss.getSinglePersons(person)
      .subscribe( {
        next: res => {
          if (!res || !res.object) {
            this.alertDispatcher.show({
              message: 'Keine Personen gefunden!',
              clrAlertType: IAlertType.WARNING
            }, 5000);
            return;
          }
          this.person = res.object;
        },
        complete: () => {
          this.personFirstName = this.person[0].firstname;
          this.personLastName = this.person[0].lastname;
          this.personSalutation = this.person[0].salutation;
          this.personEMail = this.person[0].email;
          this.personPhone = this.person[0].phone;
          this.personId = this.person[0].pid;
        },
        error: () => {
          return
        }
      });
  }

  splitProjectNumber(projectId: string, substring: number) {
    var splits = projectId.split('.');
    return splits[substring];
  }

  staffStatus(staffId: number){
    this.staffss.getStaffById(staffId)
      .subscribe({
        next: staff => {
          if (!staff) {
            return;
          }
          this.staffFirstName = staff.object[0].firstname;
          this.staffLastName = staff.object[0].lastname;
          this.staffEMail = staff.object[0].email;
          this.staffPhone = staff.object[0].phone;
        },
        complete: () => {
          if (this.devMode) console.log('StaffID ist ' + staffId);
        }
      })
  }

  getCondition(condId: number, condType:number){
    if (condId == 0) {
      this.deliveryCondition = "---";
      this.paymentCondition = "---";
      this.offerCondition = "---";
    } else {
      this.condss.getConditionById(condId, condType)
        .subscribe({
            next: condition => {

              if (!condition?.object) return;
              if (!condition.object.length) return;

              switch (condType) {
                case 1:
                  this.deliveryCondition = `${condition.object[0].name} (${condition.object[0].text})`;
                  this.deliveryConditionHasOption = condition.object[0].option ?? false;
                  break;
                case 2:
                  this.paymentCondition = condition.object[0].name;
                  break;
                case 3:
                  this.offerCondition = condition.object[0].name;
                  break;
              }
            },
            error: () => {
              return
            }
          }
        )}
  }

  async updateConfirmation(done: boolean) {
    this.editPos = 1;
    this.loadConfirmation(this.projectId, this.jobId, this.confirmationId);
    this.loadConfirmationsPosition();
  }

  deleteConfirmation(projectId: string, confirmationId: number) {
    if (confirm('Wollen Sie dieses Auftragsbestätigung wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.confss.deleteConfirmation(projectId, confirmationId)
        .subscribe({
          next: () => {
          },
          complete: () => {
            this.router.navigate(['/project/details/', this.splitProjectNumber(projectId, 0), this.splitProjectNumber(projectId, 1)]);
          },
          error: () => {
            return
          }
        });
    }
  }

  deletePosition(projectId: string, confirmationId: number, positionId: number, partId: number){
    this.confss.deleteConfirmationsPosition(projectId, confirmationId, positionId, partId)
      .subscribe({
        next: () => {
          this.loadConfirmationsPosition();
        },
        complete: () => {
          this.alertDispatcher.show({
            message: ' Position ' + positionId + '.' + partId + ' wurde gelöscht. ',
            clrAlertType: IAlertType.INFO
          }, 2000);
        },
        error: () => {
          return
        }
      });
  }

  onDelete() {
    let choosenPositions = this.selected;
    if (confirm('Wollen Sie die ausgewählten Positionen tatsächlich löschen?')) {
      choosenPositions.forEach(array => {
        // console.log("ich lösche " + array.position + '.' + array.part);
        this.deletePosition(this.projectId, this.confirmationId, array.position ?? 0, array.part ?? 0)
      });

      this.loadConfirmation(this.projectId, this.jobId, this.confirmationId);
      this.loadConfirmationsPosition();

      this.alertDispatcher.alertConfig.message = 'Die Positionen wurden gelöscht.';
      this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
    }
  }

  createConfirmation(positions: any[]) {
    let confirmationValue = 0.00;
    let formattedName = '';
    let formattedMaterial = '';
    let formattedDeliveryDate = '';
    let formattedRemarks = '';
    let delivery_receiver = this.confirmation.delivery_company;

    let posTable = [[
      { text: 'Pos.'}, { text: 'Bezeichnung' }, { text: 'Zeichnung', colSpan: 1, style: ''}, { text: 'Material' }, { text: 'Kennzeichnung' }, { text: '' }, { text: 'Anzahl' }, { text: 'Stückpreis in EUR', alignment: 'right' }]];

    positions.forEach(position => {
      formattedName = position.name;
      formattedMaterial = position.material;
      formattedRemarks = '';
      if (position.serial_nr == 'null') position.serial_nr = '';
      if (position.heat_nr == 'null') position.heat_nr = '';
      if (position.controlling_nr == 'null') position.controlling_nr = '';
      if (position.description) position.name += '\n(' + position.description + ')';
      if (position.taric && position.taric !== "0") position.name += '\n(Zolltarifnummer: ' + position.taric + ')';
      if (position.heat_nr) position.material += '\n' + position.heat_nr;
      if (position.controlling_nr) position.material += '\n' + position.controlling_nr;
      if (position.remarks) formattedRemarks = position.remarks;
      if (position.delivery_date == '2020-01-01') { formattedDeliveryDate = '' } else { formattedDeliveryDate = moment(position.delivery_date).format("DD.MM.yyyy")};

      // Angebotssumme berechnen
      if (position.technology) {
        confirmationValue = confirmationValue + parseFloat(position.selling_price);
      } else {
        confirmationValue = confirmationValue + (position.number_of_pieces*parseFloat(position.selling_price));
      }

      switch(position.part) {
        case 0: {
          if (position.technology) {
            posTable.push(
              [position.position, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', '', {
                text: formatCurrency(position.selling_price, 'de', '', 'EUR'),
                alignment: 'right'
              }]
            );
          } else {
            posTable.push(
              [position.position, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', position.number_of_pieces, {
                text: formatCurrency(position.selling_price, 'de', '', 'EUR'),
                alignment: 'right'
              }]
            );
          }

          if ( formattedRemarks != '' ) {
            posTable.push(
              [ { text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: '' },
                { text: formattedRemarks, colSpan: 4, style: 'table' },
                { text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: '' } ]
            )
          }
          break;
        }
        default: {
          if (position.technology) {
            if (position.selling_price > 0) {
              posTable.push(
                [{
                  text: position.position + '.' + position.part,
                  margin: [10, 0]
                }, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', '', {
                  text: formatCurrency(position.selling_price, 'de', '', 'EUR'),
                  alignment: 'right'
                }]
              );
            } else {
              posTable.push(
                  [{
                    text: position.position + '.' + position.part,
                    margin: [10, 0]
                  }, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', '', '']
              );
            }
          } else {
            if (position.selling_price > 0) {
              posTable.push(
                [{
                  text: position.position + '.' + position.part,
                  margin: [10, 0]
                }, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', position.number_of_pieces, {
                  text: formatCurrency(position.selling_price, 'de', '', 'EUR'),
                  alignment: 'right'
                }]
              );
            } else {
              posTable.push(
                  [{
                    text: position.position + '.' + position.part,
                    margin: [10, 0]
                  }, formattedName, position.technical_drawing, formattedMaterial, position.serial_nr, '', position.number_of_pieces, '']
              );
            }
          }

          if ( formattedRemarks != '' ) {
            posTable.push(
              [{ text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: '' },
                { text: formattedRemarks,  colSpan: 4, style: 'table'  },
                { text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: '' }, { text: '', colSpan: 1, style: ''}, { text: '', colSpan: 1, style: '' } ]
            )
          }
          break;
        }
      }
    });

    if (this.confirmation.cond_offer == 0) { this.offerCondition = '' } else { this.offerCondition = '\n' + this.offerCondition }
    if (!this.confirmation.delivery_remarks) { this.confirmation.delivery_remarks = '---'}

    let footTable1 = [
      [ 'Preis gesamt:', formatCurrency(confirmationValue, 'de', 'EUR', 'EUR') + ' netto, zzgl. gesetzlicher MWSt.' + this.offerCondition ],
      [ 'Lieferbedingungen:', 'einschließlich transportfähiger und zweckmäßiger Verpackung' ],
      [ 'Lieferdatum:', moment(this.confirmation.delivery_date).format("DD.MM.yyyy") ],
      [ 'Bemerkungen zur Lieferzeit:', this.confirmation.delivery_remarks + '\n(im Rahmen freier Kapazitäten, Materialverfügbarkeit zum Zeitpunkt der Bestellung vorausgesetzt)' ]
    ];

    let footTable2 = [
      [ 'Lieferung:', this.deliveryCondition + '\n(gemäß Incoterms®2020 http://www.incoterms2020.de)']
    ];

    if (this.deliveryConditionHasOption && this.confirmation.delivery_company) {
      if (this.confirmation.delivery_department) delivery_receiver += '\n' + this.confirmation.delivery_department;
      footTable2.push(
        [ 'Lieferadresse: ', delivery_receiver  + '\n' + this.confirmation.delivery_street + '\n' + this.confirmation.delivery_postcode + ' ' + this.confirmation.delivery_city + '\n' + this.confirmation.delivery_country ]
      )
    }

    footTable2.push(
      [ 'Zahlungsbedingungen:', this.paymentCondition ],
      [ 'Gewährleistung:', 'zeichnungsgerechte Fertigung mit Prüf- und Messdokumentation' ],
      [ 'Haftung:', 'entsprechend BGB in der gültigen Fassung vom 02.01.2002' ],
    )

    this.documentDefinition.info.title = 'PPS Auftragsbestätigung';
    this.documentDefinition.info.subject = 'AUFTRAGSBESTÄTIGUNG ' + this.projectId + '.0008.' + this.confirmationId;
    this.documentDefinition.info.revison = this.ppsverion;

    (this.documentDefinition.content[0] as any).columns[0].text = this.confirmation.company_name + '\n' + this.confirmation.street + '\n' + this.confirmation.postcode + ' ' + this.confirmation.city;
    if(this.confirmation.country && (this.confirmation.country != 'Deutschland')) {
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + this.confirmation.country
    }
    if(this.confirmation.employee_leader) {
      (this.documentDefinition.content[0] as any).columns[0].text += '\n\n' + this.personSalutation + ' ' + this.personLastName;
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + this.personPhone;
      (this.documentDefinition.content[0] as any).columns[0].text += '\n' + this.personEMail;
    }

    (this.documentDefinition.content[0] as any).columns[2].text = this.tenantConfig.letterCity + ', ' + moment(this.confirmation.confirmation_date).format("DD.MM.yyyy") + '\n\nIhr Ansprechpartner:\n' + this.staffFirstName + ' ' + this.staffLastName + '\n' + this.staffEMail;
    (this.documentDefinition.content[1] as any).text = 'AUFTRAGSBESTÄTIGUNG ' + this.projectId + '.0008.' + this.confirmationId ;
    (this.documentDefinition.content[2] as any).text = 'gemäß Auftrag: ' + this.confirmation.order_id + '\nJob-Nummer: '  + this.projectId + '.0006.' + this.jobId;

    (this.documentDefinition.content[3] as any).text = 'Sehr geehrte(r) ' + this.personSalutation + ' ' + this.personLastName + ',\n\nWir bestätigen Ihnen hiermit die termin- und qualitätsgerechte Fertigung von untenstehendem Umfang:\n\n';

    (this.documentDefinition.content[4] as any).table.headerRows = 1;
    (this.documentDefinition.content[4] as any).table.widths = [ 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
    (this.documentDefinition.content[4] as any).table.body = posTable;
    // Footer-Tabelle für Summen/Conditions wieder befüllen (war zuletzt auskommentiert).
    (this.documentDefinition.content[5] as any).table.body = [...footTable1, ...footTable2];
    /*this.documentDefinition.content.splice(6, 0, {
      text = ' Eigentumsvorbehalt\n' +
        'Unsere Waren bzw. Leistungen bleiben unser Eigentum bis zur vollständigen Bezahlung aller aus der Geschäftsverbindung entstandenen Verbindlichkeiten, auch bei Weiterveräußerung und Konkurs.\n' +
        'Sie treten etwaige Ansprüche aus Weiterveräußerung schon jetzt an uns ab. Wir haften nur in Höhe des oben angebotenen Umfanges.\n' +
        'Reklamationen werden nur innerhalb von 10 Tagen nach Lieferung durch uns anerkannt (soweit nichts anderes vereinbart). Der Eigentumsvorbehalt gilt als vertraglich vereinbart, wenn hierzu keine schriftliche Einrede erfolgt.\n\n' +
        'Bei Lieferung ab Werk, unverpackt: das von Ihnen beauftragte Transportunternehmen hat für ausreichend Frachtsicherungsmaterial zu sorgen; für den Fall, dass wir Holzkeile, Balken, Spanngurte, Verpackungsmaterial etc. zur Verfügung stellen, werden wir diese Kosten separat in Rechnung stellen.\n\n' + 'Es gelten unsere Allgemeinen Einkaufs- und Lieferbedingungen.' ;
    }*/

    this.generatePdf();
  }

  generatePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);

    documentGenerator.getDataUrl((dataUrl: string) => {
      const targetElement = document.querySelector('#documentContainer');
      targetElement!.innerHTML = '';

      if (!targetElement) {
        this.alertDispatcher.alertConfig.message = 'PDF-Container nicht gefunden!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
        return; // Exit the function if the element doesn't exist
      }

      const pdfIframe = document.createElement('iframe');
      pdfIframe.src = dataUrl;
      pdfIframe.width = '100%';
      pdfIframe.height = '100%';
      targetElement.appendChild(pdfIframe);
    })
  }

  archivePdf() {
    if (confirm('Wollen Sie die Datei ' + 'Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf archivieren?')) {
      this.safePdf();
    }

    this.alertDispatcher.show({
      message: ' Datei ' + 'Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf wurde archiviert.',
      clrAlertType: IAlertType.SUCCESS
    }, 5000);
  }

  async downloadPdf(){
    if (confirm('Wollen Sie die Datei ' + 'Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf wirklich herunterladen?')) {
      const documentGenerator = pdfMake.createPdf(this.documentDefinition).download('Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf');
    }

    await this.safePdf();

    this.alertDispatcher.alertConfig.message = 'Datei ' + 'Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf wurde herunterladen.';
    this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
  }

  async printPdf() {
    if (confirm('Wollen Sie die Datei ' + 'Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf ausdrucken?')) {
      pdfMake.createPdf(this.documentDefinition).print();
    }

    await this.safePdf()

    this.alertDispatcher.show({
      message: ' Datei ' + 'Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf wurde an den Drucker übergeben. ',
      clrAlertType: IAlertType.INFO
    }, 2000);
  }

  safePdf() {
    const documentGenerator = pdfMake.createPdf(this.documentDefinition as any);
    documentGenerator.getBlob((blob: Blob) => {
      // Convert Blob to File
      const file = new File(
        [blob], // Blob content
        'Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf',
        { type: blob.type, lastModified: Date.now() } // File metadata
      );

      // Now, send the file instead of the Blob
      this.filess.sendFile(file, 6, this.confirmation.confirmation_id, this.confirmation.project_id, this.jobId, '', 'Confirmation_' + this.confirmation.project_id + '.0003.' + this.confirmation.confirmation_id)
        .subscribe({
          next: (data) =>
          {
            if (this.devMode) console.log("done")
          },
          complete: () => {
            this.alertDispatcher.show({
              message: ' Datei ' + 'Confirmation_' + this.confirmation.project_id + '.0008.' + this.confirmation.confirmation_id + '.pdf wurde gespeichert.',
              clrAlertType: IAlertType.SUCCESS
            }, 5000);
          },
          error: (error) => console.error("Error:", error)
        });
    });
  }
}
